export const PACKAGE_KEY = {
  PRIME: {
    279: {
      M1: "PRIME279M1",
      S1: "PRIME279S1",
      M1DC10: "PRIME279M1DC10",
      M1DC05: "PRIME279M1DC05",
      S1DC10: "PRIME279S1DC10",
      S1DC05: "PRIME279S1DC05",
      MS99: "PRIME279MS99",
    },
    289: {
      M1: "PRIME289M1",
      S1: "PRIME289S1",
      M1DC10: "PRIME289M1DC10",
      M1DC05: "PRIME289M1DC05",
      S1DC10: "PRIME289S1DC10",
      S1DC05: "PRIME289S1DC05",
      MS99: "PRIME289MS99",
      V6: "PAYBK289V6",
      V2: "PAYBK289V2",
      MS389: "PRIME389MS389",
      V11: "PAYBK289V11",
      M1TDT: "PRIME289M1TDT",
      M1DC10TDT: "PRIME289M1DC10TDT",
      S1M10DC20: "PRIME289S1M10DC20",
      S1M30DC40: "PRIME289S1M30DC40",
      MS99DC2D97: "PRIME289MS99DC2D97",
      MS99DC12D97: "PRIME289MS99DC12D97",
      MS99DC12D97MT: "PRIME289MS99DC12D97MT",
      M1DC20: "PRIME289M1DC20",
      S1DC20: "PRIME289S1DC20",
      MS99DC22D97MT: "PRIME289MS99DC22D97MT",
    },
    379: {
      MS379: "PRIME379MS379",
    },
    389: {
      MS389: "PRIME389MS389",
    },
  },
  PAYBK: {
    279: {
      V11: "PAYBK279V11",
    },
    289: {
      V6: "PAYBK289V6",
      V2: "PAYBK289V2",
      V11: "PAYBK289V11",
      V12: "PAYBK289V12",
    },
  },
  SALES: {
    289: {
      PAY1DC10: "SALES289PAY1DC10",
      PAY10DC10: "SALES289PAY10DC10",
      PAY1DC20: "SALES289PAY1DC20",
      PAY1DC20BNF: "SALES289PAY1DC20BNF",
    },
  },
};
